import React from "react";
import { Link } from "react-router-dom";

/**
 * AuthorByline — compact byline used in Article header and PostCard footer.
 * Accepts either a full author object (preferred, from /api/authors)
 * or a plain string name (fallback for legacy posts).
 *
 * size="sm" for card, size="md" for article header
 */
export function AuthorByline({ author, authorSlug, size = "sm", linkable = true, dateLabel }) {
  // Fallback for legacy posts that only carry the author name string
  const isObj = author && typeof author === "object";
  const name = isObj ? author.name : author || "Equipe Viagens Orion";
  const slug = isObj ? author.slug : authorSlug || "equipe-viagens-orion";
  const role = isObj ? author.short_role : "";
  const photo = isObj ? author.photo_url : null;
  const position = isObj ? author.photo_position || "center" : "center";

  const avatarSize = size === "md" ? "h-12 w-12" : "h-9 w-9";
  const nameSize = size === "md" ? "text-sm" : "text-[11px]";

  const avatar = (
    <span className={`inline-block ${avatarSize} rounded-full overflow-hidden ring-1 ring-orion-gold/40 flex-shrink-0`}>
      {photo ? (
        <img src={photo} alt={name} loading="lazy" decoding="async" width="72" height="72" className="h-full w-full object-cover" style={{ objectPosition: position }} />
      ) : (
        <span className="h-full w-full flex items-center justify-center bg-orion-purple text-white text-xs">
          {name?.split(" ").map((n) => n[0]).slice(0, 2).join("")}
        </span>
      )}
    </span>
  );

  const nameNode = (
    <span
      className={`font-semibold ${nameSize} uppercase tracking-[0.18em] text-orion-purple`}
      data-testid={`author-name-${slug}`}
    >
      {name}
    </span>
  );

  return (
    <div className={`flex items-center gap-3 ${size === "md" ? "text-sm" : "text-xs"}`} data-testid="author-byline">
      {linkable ? <Link to={`/autor/${slug}`}>{avatar}</Link> : avatar}
      <div className="leading-tight">
        {linkable ? <Link to={`/autor/${slug}`} className="hover:text-orion-orange">{nameNode}</Link> : nameNode}
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#8A8191] mt-0.5">
          {role || "Equipe editorial"}
          {dateLabel && <> · <span className="text-orion-gold">{dateLabel}</span></>}
        </div>
      </div>
    </div>
  );
}

export default AuthorByline;
